import { render } from "./GenericPdfMgtSummaryTable.vue?vue&type=template&id=1e286289&scoped=true&ts=true"
import script from "./GenericPdfMgtSummaryTable.vue?vue&type=script&lang=ts"
export * from "./GenericPdfMgtSummaryTable.vue?vue&type=script&lang=ts"

import "./GenericPdfMgtSummaryTable.vue?vue&type=style&index=0&id=1e286289&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e286289"]])

export default __exports__